var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpLevel24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.798 15.673a.942.942 0 001.602-.662V11.9a.237.237 0 01.236-.237h12.772a.235.235 0 01.235.237v4.918A1.184 1.184 0 0021.822 18 1.176 1.176 0 0023 16.818V10.48a1.184 1.184 0 00-1.178-1.182H7.683a.245.245 0 01-.236-.237v-3.12a.948.948 0 00-.575-.87.94.94 0 00-1.027.207L1.283 9.81a.946.946 0 00-.283.672c.004.25.105.488.283.662l4.515 4.53z",
    fill: "#002147"
  })));
}
export default SvgIconUpLevel24;